import { Box } from '@mantine/core';
import type { ComponentProps } from 'react';
import { StatementInfo } from './StatementInfo';
import { StatementRevenueSummary } from './StatementRevenueSummary';

type Props = {
  info: ComponentProps<typeof StatementInfo>;
  summary: ComponentProps<typeof StatementRevenueSummary>;
};

export const StatementHeader = ({ info, summary }: Props) => {
  return (
    <Box
      sx={(theme) => ({
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        flexDirection: 'row',
        gap: theme.spacing.xl,
        paddingTop: theme.spacing.lg,
        marginBottom: theme.spacing.xl,
        '& > *': {
          width: '100%',
          flexGrow: 1,
        },
        [`@media (max-width: ${theme.breakpoints.md})`]: {
          flexDirection: 'column',
        },
      })}
    >
      <StatementInfo {...info} />
      <Box
        sx={{
          flex: 0.7,
        }}
      >
        <StatementRevenueSummary {...summary} />
      </Box>
    </Box>
  );
};
